import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../../context/SocketContext';
import './ActiveJobsList.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const ActiveJobsList = ({ userRole }) => {
  const navigate = useNavigate();
  const socket = useSocket();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobs = useCallback(async () => {
    try {
      const token = localStorage.getItem('marilink_token');
      if (!token) return;

      let endpoint = userRole === 'owner' ? `${API_BASE}/rfqs` : userRole === 'service-provider' ? `${API_BASE}/contracts` : `${API_BASE}/rfqs`;
      
      const response = await fetch(endpoint, { headers: { Authorization: `Bearer ${token}` } });
      const data = await response.json();
      if (!data.success) return;

      let formattedJobs = [];
      if (userRole === 'owner') {
        formattedJobs = (data.rfqs || [])
          .filter(rfq => ['open', 'bidding', 'in_progress'].includes(rfq.status))
          .slice(0, 5)
          .map(rfq => ({
            id: rfq._id,
            vessel: rfq.vesselName,
            service: rfq.serviceType,
            port: rfq.port,
            budget: rfq.budgetType === 'quotation' ? 'RFQ' : `$${(rfq.budgetMin || rfq.budget || 0).toLocaleString()}`,
            status: rfq.status,
            deadline: rfq.deadline ? new Date(rfq.deadline).toLocaleDateString() : 'N/A',
          }));
      }
      setJobs(formattedJobs);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [userRole]);

  useEffect(() => { fetchJobs(); }, [fetchJobs]);

  const handleJobClick = (job) => {
    navigate(userRole === 'owner' ? `/owner/job/${job.id}` : `/service-provider/active-work`);
  };

  const getStatusText = (status) => {
    if (status === 'open') return 'Open';
    if (status === 'bidding') return 'With Offers';
    if (status === 'in_progress') return 'In Progress';
    return status;
  };

  if (loading) return <div className="aj-wrapper"><div className="aj-empty">Loading...</div></div>;

  return (
    <div className="aj-wrapper">
      <div className="aj-header">
        <h3 className="aj-title"><i className="fa-solid fa-briefcase"></i> Active Jobs</h3>
        <span className="aj-count">{jobs.length} records</span>
      </div>
      
      {jobs.length === 0 ? (
        <div className="aj-empty">No active jobs found.</div>
      ) : (
        <div className="aj-list">
          {jobs.map(job => (
            <div key={job.id} className="aj-item" onClick={() => handleJobClick(job)}>
              <div className="aj-info">
                <div className="aj-vessel">{job.vessel}</div>
                <div className="aj-service">{job.service}</div>
                <div className="aj-meta">
                  <span><i className="fa-solid fa-location-dot"></i> {job.port || 'TBD'}</span>
                  <span><i className="fa-solid fa-money-bill"></i> {job.budget}</span>
                </div>
              </div>
              <div className="aj-status">
                {getStatusText(job.status)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActiveJobsList;